<template>
    <div
        class="form-control d-flex flex-nowrap"
        :class="{
            'text-end align-items-end justify-content-end': props.type == 'timespan' || props.type == 'date' || props.type == 'number',
        }"
        :style="{
            'min-width': props.type == 'timespan' ? '150px !important' : 'unset',
            cursor: 'text',
        }"
    >
        &nbsp;
        <slot></slot>
    </div>
</template>
<script lang="ts" setup>
/**
 * Helper to display something that looks like an input but is actually just a div. This is useful for when you want to display
 * something that looks like an input but is not editable, but you still want it to look like an input for consistency with other inputs.
 */

export type DisplayAsInputComponent = 'date' | 'string' | 'number' | 'timespan';

const props = withDefaults(
    defineProps<{
        type?: DisplayAsInputComponent;
    }>(),
    {},
);
</script>
